import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/user',
      component: () => import('./views/user/login.vue'),
      children: [
        {
          path: 'user',
          component: () => import('./views/user/login.vue'),
          meta: { title: '登录' }
        }
      ]
    },

    {
      path: '/user/qrcode-scan',
      name: 'qrcodeScan',
      component: () => import('./views/user/qrcode-scan.vue'),
      meta: { title: '扫一扫' }
    },
    {
      path: '/user/haoka17',
      component: () => import('./views/user/haoka17.vue'),
      meta: { title: '活动' }
    },
    {
      path: '/user/loginDev',
      component: () => import('./views/user/loginDev.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/she/loginBind',
      component: () => import('./views/user/loginBind.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/user/sysAuth',
      component: () => import('./views/user/sysAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/applyChg',
      component: () => import('./views/user/applyChg.vue'),
      meta: { title: '换卡申请' }
    },
    {
      path: '/user/cmccTwoAuth',
      component: () => import('./views/user/cmccTwoAuth'),
      meta: { title: '二次认证' }
    },
    {
      path: '/user/jiujiu',
      component: () => import('./views/user/loginAuth.vue')
    },
    {
      path: '/user/bindPhone',
      component: () => import('./views/user/bindPhone.vue')
    },
    {
      path: '/user/home',
      component: () => import('./views/user/home.vue'),
      meta: { title: '业务中心' }
    },
    {
      path: '/user/queryFlux',
      component: () => import('./views/user/queryFlux.vue'),
      meta: { title: '流量查询' }
    },
    {
      path: '/user/cuccAuth',
      component: () => import('./views/user/cuccAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/cuccAuthUrl',
      component: () => import('./views/user/cuccAuthUrl.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/cmccAuth',
      component: () => import('./views/user/cmccAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/ctccGdAuth',
      component: () => import('./views/user/ctccGdAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/shebeiAuth',
      component: () => import('./views/user/shebeiAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/loginCt',
      component: () => import('./views/user/loginCt.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/loginCu',
      component: () => import('./views/user/loginCu.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/shebeiAuthCt',
      component: () => import('./views/user/shebeiAuthCt.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/shebeiAuthCu',
      component: () => import('./views/user/shebeiAuthCu.vue'),
      meta: { title: '实名认证' }
    },

    {
      path: '/user/ctccAuth',
      component: () => import('./views/user/ctccAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/recharge',
      component: () => import('./views/user/recharge.vue'),
      meta: { title: '套餐订购' }
    },
    {
      path: '/user/verified',
      component: () => import('./views/user/verified.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/haoka2',
      name: 'placeOrder',
      component: () => import('./views/user/haoka2.vue'),
      meta: { title: '' }
    },
    {
      path: '/user/haokaHome',
      component: () => import('./views/user/haokaHome.vue'),
      meta: { title: '在线办理' }
    },


    {
      path: '/user/rechargeDetail',
      name: 'rechargeDetail',
      component: () => import('./views/user/rechargeDetail.vue'),
      meta: { title: '充值详情' }
    },
    {
      path: '/user/submitSuccessPage',
      name: 'submitSuccessPage',
      component: () => import('./views/user/submitSuccessPage.vue'),
      meta: { title: '提交成功' }
    },
    {
      path: '/user/orderSearch',
      name: 'orderSearch',
      component: () => import('./views/user/orderSearch.vue'),
      meta: { title: '订单查询' }
    },
    {
      path: '/user/orderSearchDetails',
      name: 'orderSearchDetails',
      component: () => import('./views/user/orderSearchDetails.vue'),
      meta: { title: '订单查询' }
    },
    {
      path: '/user/feedback',
      redirect: '/user/feedback/question',
      component: () => import('./views/user/feedback.vue'),
      children: [
        {
          path: 'list',
          component: () => import('./views/user/question.vue')
        },
        {
          path: 'question',
          component: () => import('./views/user/submitQuestion.vue')
        }
      ],
      meta: { title: '问题反馈' }
    },
    {
      path: '/user/buyCard',
      redirect: '/user/buyCard/buyChangeCard',
      component: () => import('./views/user/buyCard.vue'),
      children: [
        {
          path: 'buyChangeCard',
          component: () => import('./views/user/buyChangeCard.vue')
        },
        {
          path: 'buyChangeCardQuestion',
          component: () => import('./views/user/buyChangeCardQuestion.vue')
        }
      ],
      meta: { title: '购买卡' }
    },
    {
      path: '/user/questionDetail',
      component: () => import('./views/user/questionDetail.vue'),
      meta: { title: '问题详情' }
    },
    {
      path: '/user/applyMy',
      component: () => import('./views/user/applyMy.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/openPrice',
      component: () => import('./views/user/openPrice.vue'),
      meta: { title: '开户激活' }
    },
    {
      path: '/user/bindPhoneOnely',
      component: () => import('./views/user/bindPhoneOnely.vue'),
      meta: { title: '手机绑定' }
    },
    {
      path: '/user/chgCardQuery',
      component: () => import('./views/user/chgCardQuery.vue'),
      meta: { title: '换卡中心' }
    },
    {
      path: '/user/userChgCard',
      name: 'userChgCard',
      component: () => import('./views/user/userChgCard.vue'),
      meta: { title: '换卡中心' }
    },
    {
      path: '/user/realName',
      name: 'realName',
      component: () => import('./views/user/realName.vue'),
      meta: { title: '实名中心' }
    },
    {
      path: '/agent/login',
      component: () => import('./views/agent/login.vue'),
      meta: { title: '商户登录' }
    },
    {
      path: '/agent/card',
      component: () => import('./views/agent/card.vue'),
      meta: { title: '卡片管理' }
    },
    {
      path: '/agent/card2',
      component: () => import('./views/agent/card2.vue'),
      meta: { title: '套餐管理' }
    }, {
      path: '/agent/addUser',
      component: () => import('./views/agent/addUser.vue'),
      meta: { title: '客户管理' }
    },
    {
      path: '/agent/withdrawal',
      component: () => import('./views/agent/withdrawal.vue'),
      meta: { title: '提现申请' }
    },
    {
      path: '/agent/tiLog',
      component: () => import('./views/agent/tiLog.vue'),
      meta: { title: '提现记录' }
    },
    {
      path: '/agent/home',
      component: () => import('./views/agent/home.vue'),
      meta: { title: '业务中心' }
    },
    {
      path: '/agent/secondBack',
      component: () => import('./views/agent/secondBack.vue'),
      meta: { title: '秒返设置' }
    },
    {
      path: '/agent/distribut',
      component: () => import('./views/agent/simDistribut.vue'),
      meta: { title: '卡片分销' }
    },
    {
      path: '/agent/notify',
      component: () => import('./views/agent/notify.vue'),
      meta: { title: '我的公告' }
    },
    {
      path: '/agent/notifyDetail',
      name: 'notifyDetail',
      component: () => import('./views/agent/notifyDetail.vue'),
      meta: { title: '公告详情' }
    },
    {
      path: '/user/diagnosis',
      component: () => import('./views/user/diagnosis.vue'),
      meta: { title: '智能检测' }
    },
    {
      path: '/user/diagnosisLogin',
      component: () => import('./views/user/diagnosisLogin.vue'),
      meta: { title: '智能检测' }
    },


    {
      path: '/agent/distributRecord',
      component: () => import('./views/agent/distributRecord.vue'),
      meta: { title: '分销记录' }
    },
    {
      path: '/agent/recharge',
      component: () => import('./views/agent/recharge.vue'),
      meta: { title: '预充值' }
    },
    {
      path: '/agent/rechargeRecord',
      component: () => import('./views/agent/rechargeRecord.vue'),
      meta: { title: '预充值记录' }
    },
    {
      path: '/agent/onlineService',
      component: () => import('./views/agent/onlineService.vue'),
      meta: { title: '在线客服' }
    },
    {
      path: '/user/couponToReceive',
      component: () => import('./views/user/couponToReceive.vue'),
      meta: { title: '领券中心' }
    },
    {
      path: '/user/cardSetUp',
      component: () => import('./views/user/cardSetUp.vue'),
      meta: { title: '充值中心' }
    },
    {
      path: '/user/balanceRecharge',
      component: () => import('./views/user/balanceRecharge.vue'),
      meta: { title: '余额充值' }
    },
    {
      path: '/user/rechargeAuto',
      component: () => import('./views/user/rechargeAuto.vue'),
      meta: { title: '自动续费' }
    },
    {
      path: '/user/balanceRechargeRecord',
      component: () => import('./views/user/balanceRechargeRecord.vue'),
      meta: { title: '充值记录' }
    },
    {
      path: '/user/notify',
      component: () => import('./views/user/notify.vue'),
      meta: { title: '我的公告' }
    },
    {
      path: '/user/returnPostage',
      component: () => import('./views/user/returnPostage.vue'),
      meta: { title: '邮费退还' }
    },
    {
      path: '/user/Advertisement',
      component: () => import('./components/Advertisement.vue'),
      meta: { title: '聚量广告' }
    },
    {
      path: '/user/login2',
      component: () => import('./views/user/login2.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/user/buyCard2',
      component: () => import('./views/user/buyChangeCard2.vue'),
      meta: {
        title: '申请买卡'
      },

    },
    {
      path: '/agent/pkg',
      component: () => import('./views/agent/pkg.vue'),
      meta: { title: '套餐类别' }
    },
    {
      path: '/agent/myprice',
      component: () => import('./views/agent/myprice.vue'),
      meta: { title: '佣金明细' }
    },
    {
      path: '/agent/buysim',
      component: () => import('./views/agent/buysim.vue'),
      meta: { title: '买卡列表' }
    },
    {
      path: '/agent/myorder',
      component: () => import('./views/agent/myorder.vue'),
      meta: { title: '订单管理' }
    },
    {
      path: '/user/buyAgentCard',
      component: () => import('./views/user/buyAgentCard.vue'),
      meta: { title: '领卡' }
    },
    {
      path: '/user/leyuAuth',
      component: () => import('./views/user/leyuAuth.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/orderLog',
      component: () => import('./views/user/balanceRechargeRecordApp.vue'),
      meta: { title: '套餐记录' }
    },
    {
      path: '/user/accountLog',
      component: () => import('./views/user/balancAppAcountFlow.vue'),
      meta: { title: '充值记录' }
    },
    {
      path: '/user/selectBindPhone',
      component: () => import('./views/user/selectBindPhone.vue'),
      meta: { title: '查询单号' }
    },
    {
      path: '/user/AppLoad',
      component: () => import('./views/user/AppLoad.vue'),
      meta: { title: '安卓APP下载' }
    },
    {
      path: '/user/AppLoadp',
      component: () => import('./views/user/AppLoadp.vue'),
      meta: { title: '苹果APP下载' }
    },
    {
      path: '/user/accountInfo',
      component: () => import('./views/user/balancAppAcount.vue'),
      meta: { title: '余额记录' }
    },



    {
      path: '/user/haoka3',
      component: () => import('./views/user/haoka3.vue'),
      meta: { title: '靓号免费领，包邮到家' }
    },

    {
      path: '/user/buyChangHome',
      component: () => import('./views/user/buyChangHome.vue'),
      meta: { title: '买卡列表' }
    },
    {
      path: '/user/liuliangka',
      component: () => import('./views/buy/home.vue'),
      meta: { title: '商城' }
    },
    {
      path: '/user/buyCardHome',
      component: () => import('./views/user/buyCardHome.vue'),
      meta: { title: '购卡' }
    },
    {
      name: 'buyOrderSearch',
      path: '/user/buyOrderSearch',
      component: () => import('./views/user/buyOrderSearch.vue'),
      meta: { title: '订单查询' }
    },
    {
      name: 'buyOrderSearchDetails',
      path: '/user/buyOrderSearchDetails',
      component: () => import('./views/user/buyOrderSearchDetails.vue'),
      meta: { title: '订单查询' }
    },




    {
      path: '/user/AppALoad',
      component: () => import('./views/user/AppALoad.vue'),
      meta: { title: 'APP下载' }
    },
    {
      path: '/user/uniappPay',
      component: () => import('./views/user/AppAPay.vue'),
      meta: { title: '支付' }
    },
    {
      path: '/user/AppAwPay',
      component: () => import('./views/user/AppAwPay.vue'),
      meta: { title: '支付' }
    },
    {
      path: '/user/AppASee',
      component: () => import('./views/user/AppASee.vue'),
      meta: { title: '苹果安装教程' }
    },
    {
      path: '/user/loginShe',
      component: () => import('./views/user/loginShe.vue'),
      meta: { title: '设备管理' }
    },
    {
      path: '/user/loginDaFa',
      component: () => import('./views/user/loginSheMy.vue'),
      meta: { title: '设备管理' }
    },
    {
      path: '/user/shebeiMgr',
      component: () => import('./views/user/shebeiMgr.vue'),
      meta: { title: '设备管理' }
    },

    {
      path: '/user/shebeiMgrUser',
      component: () => import('./views/user/shebeiMgrUser.vue'),
      meta: { title: '设备管理' }
    },
    {
      path: '/user/loginSheMyUser',
      component: () => import('./views/user/loginSheMyUser.vue'),
      meta: { title: '设备管理' }
    },
    {
      path: '/user/shebeiAuthCtcc',
      component: () => import('./views/user/shebeiAuthCtcc.vue'),
      meta: { title: '设备实名' }
    },





    //20240702新功能

    {
      path: '/new/login',
      component: () => import('./views/new/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/new/loginNo',
      component: () => import('./views/new/loginNo.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/new/home',
      component: () => import('./views/new/homeTwo.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/new/homeTwo',
      component: () => import('./views/new/homeTwo.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/new/balanceRecharge',
      component: () => import('./views/new/balanceRecharge.vue'),
      meta: { title: '充值' }
    },
    {
      path: '/new/package',
      component: () => import('./views/new/package.vue'),
      meta: { title: '套餐' }
    },
    {
      path: '/new/payment',
      component: () => import('./views/new/payment.vue'),
      meta: { title: '支付' }
    },
















    {
      path: '/she/business',
      component: () => import('./views/she/business.vue'),
      meta: { title: '业务中心' }
    },
    {
      path: '/she/sealMenu',
      component: () => import('./views/she/sealMenu.vue'),
      meta: { title: '套餐订购' }
    },
    {
      path: '/she/home',
      component: () => import('./views/she/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/she/login',
      component: () => import('./views/she/login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/she/balanceRecharge',
      component: () => import('./views/she/balanceRecharge.vue'),
      meta: { title: '余额充值' }
    },




    {
      path: '/user/simKefu',
      component: () => import('./views/user/simKefu.vue'),
      meta: { title: '卡号查询' }
    },


    {
      path: '/user/achangeKefu',
      component: () => import('./views/user/achangeKefu.vue'),
      meta: { title: '' }
    },
    {
      path: '/user/achangeKefuLogin',
      component: () => import('./views/user/achangeKefuLogin.vue'),
      meta: { title: '联系客服' }
    },

    {
      path: '/user/simKefuLogin',
      component: () => import('./views/user/simKefuLogin.vue'),
      meta: { title: '联系客服' }
    },




    {
      path: '/buy/home',
      component: () => import('./views/buy/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/buy/order',
      component: () => import('./views/buy/order.vue'),
      meta: { title: '订单' }
    },
    {
      path: '/buy/userInfo',
      component: () => import('./views/buy/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/buy/login',
      component: () => import('./views/buy/login.vue'),
      meta: { title: '登录' }
    },

  ]
})
